module.exports = __webpack_public_path__ + "static/media/Surveyor.e3164fba.jpg";